var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation15X = function SvgLocation15X(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#858F99",
    fillRule: "evenodd",
    d: "M8 .5c3.588 0 6.5 2.864 6.5 6.402 0 2.361-2.069 5.313-6.169 8.935a.5.5 0 0 1-.662 0C3.569 12.215 1.5 9.263 1.5 6.902 1.5 3.364 4.412.5 8 .5m0 1c-3.04 0-5.5 2.42-5.5 5.402 0 1.928 1.822 4.583 5.5 7.89 3.678-3.307 5.5-5.962 5.5-7.89C13.5 3.92 11.04 1.5 8 1.5m0 2a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m0 1a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
  })));
};
export default SvgLocation15X;